import { baseApi } from "./baseApi";
import type { Opportunity } from "../../Interfaces/OpportunitiesInterface";

export interface OpportunitiesListResponse {
  data: Opportunity[];
  pagination?: {
    total?: number;
    page?: number;
    limit?: number;
    totalPages?: number;
    hasNext?: boolean;
    hasPrevious?: boolean;
  };
  total?: number;
  page?: number;
  limit?: number;
  totalPages?: number;
  hasMore?: boolean;
}

export const opportunitiesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOpportunitiesList: builder.query<
      OpportunitiesListResponse,
      { tab?: string; page?: number; limit?: number }
    >({
      query: ({ tab, page = 1, limit = 50 }) => ({
        url: "/opportunities",
        params: {
          ...(tab ? { tab } : {}),
          page,
          limit,
        },
      }),
      providesTags: ["Opportunities"],
    }),
  }),
});

export const { useGetOpportunitiesListQuery } = opportunitiesApi;
